import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import action from '../history-action';
import Selectors from '../history-selecter';
import SalaryHistoryPresentational from './salary-history-presentational';

const formatData = (data) => {
	return (data || []).filter((data) => data.name);
};

const SalaryHistoryFunctional = ({ historyDepartmentSaga, departmentDetails }) => {
	const [toggleAllDepartment, setToggleAllDepartment] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [selectedDepartment, setSelectedDepartment] = useState([]);
	const [options, setOptions] = useState([
		{
			name: '',
			id: '',
			isSelected: false,
		},
	]);
	const { departmentList } = departmentDetails;
	const handleAllDepartment = (value = false) => {
		setToggleAllDepartment(value);
		handleOptionChange(null, 'ALL', value);
	};

	useEffect(() => {
		if (toggleAllDepartment) {
			const hasSelectedValues = options.filter((option) => option.isSelected)?.length === options.length;
			!hasSelectedValues && setToggleAllDepartment(false);
		}
	}, [options]);
	useEffect(() => {
		historyDepartmentSaga();
	}, []);
	useEffect(() => {
		const deprt = departmentList?.map((element) => {
			return {
				name: element?.name,
				id: element?.id,
				isSelected: false,
			};
		});
		setOptions(deprt);
	}, [departmentDetails]);
	const handleOptionChange = (name, isAll = null, isSelected, edit) => {
		let lOptions = [];
		if (isAll) {
			lOptions = (options || [])?.map((option) => {
				return {
					...option,
					isSelected,
				};
			});
		} else {
			lOptions = (options || [])?.map((option) => {
				if (option?.name === name) {
					return {
						...option,
						isSelected: !option?.isSelected,
					};
				} else return option;
			});
		}
		setOptions([...lOptions]);
		if (edit === 'delete') {
			setSelectedDepartment([...lOptions]);
		}
	};
	const handleModalCancel = () => {
		if (selectedDepartment?.length !== 0) {
			setOptions([...selectedDepartment]);
		} else if (selectedDepartment?.length === 0) {
			const nArray = options?.map((data) => {
				return {
					...data,
					isSelected: false,
				};
			});
			setOptions([...nArray]);
		}
		setSelectedDepartment([...selectedDepartment]);
		setIsModalVisible(false);
	};
	const handleCancel = () => {
		setSelectedDepartment([...options]);
		setIsModalVisible(false);
	};
	return (
		<SalaryHistoryPresentational
			{...{
				options,
				departmentDetails,
				handleOptionChange,
				handleAllDepartment,
				toggleAllDepartment,
				isModalVisible,
				setIsModalVisible,
				handleCancel,
				selectedDepartment,
				handleModalCancel,
			}}
		/>
	);
};
const mapStateToProps = (state) => {
	return {
		isDepartmentLoading: Selectors.isDepartmentLoading(state),
		departmentDetails: Selectors.departmentDetails(state),
		departmentError: Selectors.departmentError(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		historyDepartmentSaga: () => dispatch(action.creators.getHistoryDepartmentStart()),
	};
};
const Connected = connect(mapStateToProps, mapDispatchToProps)(SalaryHistoryFunctional);

export default Connected;
